import {
  MdMenuBook,
  MdSchedule,
  MdRefresh,
  MdDescription
} from 'react-icons/md';
import { LessonDetails } from '../../types/lesson';

const BookOpen = MdMenuBook as any;
const Clock = MdSchedule as any;
const CircleNotch = MdRefresh as any;
const File = MdDescription as any;

interface LessonDetailsSidebarProps {
  details: LessonDetails;
}

export default function LessonDetailsSidebar({ details }: LessonDetailsSidebarProps) {
  return (
    <div className="layout-content-container flex flex-col w-[360px]">
      <h3 className="text-white text-lg font-bold leading-tight tracking-[-0.015em] px-4 pb-2 pt-4">
        Lesson Details
      </h3>
      
      <div className="flex items-center gap-4 bg-background px-4 min-h-[72px] py-2">
        <div className="text-white flex items-center justify-center rounded bg-border shrink-0 size-12">
          <BookOpen className="w-6 h-6" />
        </div>
        <div className="flex flex-col justify-center">
          <p className="text-white text-base font-medium leading-normal line-clamp-1">Subject</p>
          <p className="text-text-secondary text-sm font-normal leading-normal line-clamp-2">
            {details.subject.name} - {details.subject.topic}
          </p>
        </div>
      </div>

      <h3 className="text-white text-lg font-bold leading-tight tracking-[-0.015em] px-4 pb-2 pt-4">
        Resources
      </h3>
      
      {details.resources.map((resource) => (
        <div key={resource.id} className="flex items-center gap-4 bg-background px-4 min-h-14">
          <div className="text-white flex items-center justify-center rounded bg-border shrink-0 size-10">
            <File className="w-6 h-6" />
          </div>
          <p className="text-white text-base font-normal leading-normal flex-1 truncate">
            {resource.name}
          </p>
        </div>
      ))}
    </div>
  );
}
